import { render, staticRenderFns } from "./roomReserveConfig.vue?vue&type=template&id=5bcd4c3a"
import script from "./roomReserveConfig.vue?vue&type=script&lang=ts"
export * from "./roomReserveConfig.vue?vue&type=script&lang=ts"
import style0 from "./roomReserveConfig.vue?vue&type=style&index=0&id=5bcd4c3a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports